import React, { useState } from "react";

import { IconButton } from "components";
import { useStyles } from "./styles";
import { SortMenu } from "./SortMenu/SortMenu";
import { useIsDisabledFilterButton } from "../SearchCarMyFleet";

export const SortCarMyFleetButton = () => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isDisabledFilterButton = useIsDisabledFilterButton();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        kind="sort"
        classes={{ root: classes.iconButton }}
        onClick={handleClick}
        disabled={isDisabledFilterButton}
      />
      <SortMenu anchorEl={anchorEl} handleClose={handleClose} />
    </>
  );
};
